import { useState, useEffect } from "react";
import { Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Sidebar, Nav } from "./Sidebar";

import logo from "../files/logo.png";

export default function Header(args) {
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY && currentScroll > 80) {
        // Aşağı kaydırıyor → gizle
        if (!args.menu) setHidden(true);
      } else {
        // Yukarı kaydırıyor → göster
        setHidden(false);
      }
      setLastScrollY(currentScroll <= 0 ? 0 : currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, args.menu]);
console.log(args.device);
  return (
    <div
      style={{
        position: "sticky",
        zIndex: "5",
        top: args.device === "pc" ? "1rem" : "0",
        height: !(args.device === "phone") ? "6rem" : "4rem",
        overflow: "visible",
      }}
    >
      <header
        className={`header ${hidden ? "header--hidden" : ""}`}
        style={{
          backgroundColor: "var(--superlightbg)",
          margin: "0",
          height: !(args.device === "phone") ? "6rem" : "4rem",
          width: args.device === "pc" ? "80vw" : "100vw",
          position: args.device === "phone" ? "-webkit-sticky" : "sticky",
          justifySelf: "center",
          top: args.device === "pc" ? "1rem" : "0",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: !(args.device === "phone") ? "center" : "flex-end",
          zIndex: "3",
          boxShadow: "var(--shadow-l)",
          borderRadius: !(args.device === "phone") && "5px",
        }}
      >
        <a href="/" style={{ marginRight: !(args.device === "pc") && "auto" }}>
          <img
            alt="Logo"
            src={logo}
            style={{
              width: args.device === "pc" ? "12rem" : "8rem",
              paddingLeft: !(args.device === "pc") && "1rem",
            }}
          ></img>
        </a>

        {args.device === "phone" ? ( //telefondaysa
          //sidebar
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="link"
              style={{ fontSize: "2rem" }}
              id="menubtn"
              onClick={() => {
                args.setMenu(!args.menu);
                setHidden(false);
              }}
            >
              <MenuOutlined />
            </Button>
          </div>
        ) : (
          //değilse

          <Nav
            mode="horizontal"
            device={args.device}
            current={args.current}
            setCurrent={args.setCurrent}
          ></Nav>
        )}
      </header>
      <Sidebar
        menu={args.menu}
        device={args.device}
        current={args.current}
        setCurrent={args.setCurrent}
      ></Sidebar>
    </div>
  );
}
